import React, { useState } from "react";
import {
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    Theme,
    DialogActions,
    Grid,
    Tooltip,
    Typography,
} from "@material-ui/core";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import PermDeviceInformationIcon from "@material-ui/icons/PermDeviceInformation";
import { useTranslation } from "react-i18next";
import { createStyles, makeStyles } from "@material-ui/styles";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        phoneNumber: {
            color: "blue",
            textDecoration: "underline",
            cursor: "pointer",
        },
        icon: {
            marginRight: "8px",
        },
        button: {
            background: "#890608",
            color: "white",
            borderRadius: 100,
            fontFamily: "Josefin Sans",
            fontSize: 14,
            textTransform: "none",
            padding: "8px 14px",
            margin: "0 auto 30px auto",
            display: "flex",
            "&:hover": {
                background: "#B5551B",
            },
            "&:disabled": {
                color: "#999",
            },
        },
    })
);

interface ContactButtonProps {
    buttonStyle?: React.CSSProperties;
    buttonClassName?: string;
}

const ContactButton: React.FC<ContactButtonProps> = ({ buttonStyle, buttonClassName }) => {
    const { t } = useTranslation<'common'>();
    const [open, setOpen] = useState(false);
    const classes = useStyles();

    const toggleContact = () => {
        setOpen(!open);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <>
            <Button
                onClick={toggleContact}
                color="primary"
                style={{
                    position: "fixed",
                    bottom: "50px",
                    right: "15px",
                    zIndex: 50,
                    background: "#25d366",
                    ...buttonStyle,  // Apply custom style prop
                }}
                className={`${classes.button} ${buttonClassName}`}  // Combine default class with custom className prop
            >
                {t("label.contact")} <WhatsAppIcon />
            </Button>
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>{t("label.contactezNous")}</DialogTitle>
                <DialogContent>
                    <Grid container>
                        <Grid item md={12} lg={12} sm={12} xs={12}>
                            <span
                                style={{
                                    fontSize: 18,
                                    fontWeight: "bold",
                                    color: "black",
                                    display: "flex",
                                    alignItems: "flex-start",
                                }}
                            >
                                {t("detail-annonce.bookOnPhone")}
                                <Tooltip
                                    title={
                                        <>
                                            <Typography variant="body1">
                                                {t("detail-annonce.bookOnPhone")}
                                            </Typography>
                                            <Typography variant="body2">
                                                {t("detail-annonce.hoverTextPhone")}
                                            </Typography>
                                        </>
                                    }
                                >
                                    <PermDeviceInformationIcon
                                        style={{
                                            marginLeft: "4px",
                                            color: "#890608",
                                            verticalAlign: "bottom",
                                        }}
                                    />
                                </Tooltip>
                            </span>
                        </Grid>
                    </Grid>
                    <Grid
                        style={{
                            padding: 12,
                            marginTop: 0,
                            lineHeight: "25px",
                            color: "black",
                        }}
                    >
                        <div
                            className="text_body"
                            style={{
                                fontWeight: "normal",
                                textAlign: "center",
                                lineHeight: "1.5",
                            }}
                        >
                            {t("detail-annonce.contactServiceClient")}
                            <br />
                            <span className={classes.phoneNumber}>
                                <WhatsAppIcon
                                    className={classes.icon}
                                    style={{
                                        verticalAlign: "middle",
                                        color: "#890608",
                                    }}
                                />
                                <a
                                    href="whatsapp://send?phone=+237655959595"
                                    style={{ textDecoration: "none", color: "inherit" }}
                                >
                                    {t("detail-annonce.numéro1")}
                                </a>
                            </span>
                            <br />
                            <span className={classes.phoneNumber}>
                                <WhatsAppIcon
                                    className={classes.icon}
                                    style={{
                                        verticalAlign: "middle",
                                        color: "#890608",
                                    }}
                                />
                                <a
                                    href="whatsapp://send?phone=+237659797979"
                                    style={{ textDecoration: "none", color: "inherit" }}
                                >
                                    {t("detail-annonce.numéro2")}
                                </a>
                            </span>
                        </div>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        {t("label.fermer")}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};


// Create the new ContactButton without fixed positioning and zIndex for the sticky bar
const StickyBarContactButton: React.FC<ContactButtonProps> = ({ buttonStyle, buttonClassName }) => {
    const { t } = useTranslation<'common'>();
    const [open, setOpen] = useState(false);
    const classes = useStyles();

    const toggleContact = () => {
        setOpen(!open);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <>
            <Button
                onClick={toggleContact}
                color="primary"
                style={{
                    background: "#25d366",
                    ...buttonStyle,  // Apply custom style prop
                }}
                startIcon={<WhatsAppIcon />}
                endIcon={<KeyboardArrowDownIcon />}
                className={`${classes.button} ${buttonClassName}`}  // Combine default class with custom className prop
            >
                {t("label.contactezNous")} 
            </Button>
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>{t("label.contactezNous")}</DialogTitle>
                <DialogContent>
                    <Grid container>
                        <Grid item md={12} lg={12} sm={12} xs={12}>
                            <span
                                style={{
                                    fontSize: 18,
                                    fontWeight: "bold",
                                    color: "black",
                                    display: "flex",
                                    alignItems: "flex-start",
                                }}
                            >
                                {t("detail-annonce.bookOnPhone")}
                                <Tooltip
                                    title={
                                        <>
                                            <Typography variant="body1">
                                                {t("detail-annonce.bookOnPhone")}
                                            </Typography>
                                            <Typography variant="body2">
                                                {t("detail-annonce.hoverTextPhone")}
                                            </Typography>
                                        </>
                                    }
                                >
                                    <PermDeviceInformationIcon
                                        style={{
                                            marginLeft: "4px",
                                            color: "#890608",
                                            verticalAlign: "bottom",
                                        }}
                                    />
                                </Tooltip>
                            </span>
                        </Grid>
                    </Grid>
                    <Grid
                        style={{
                            padding: 12,
                            marginTop: 0,
                            lineHeight: "25px",
                            color: "black",
                        }}
                    >
                        <div
                            className="text_body"
                            style={{
                                fontWeight: "normal",
                                textAlign: "center",
                                lineHeight: "1.5",
                            }}
                        >
                            {t("detail-annonce.contactServiceClient")}
                            <br />
                            <span className={classes.phoneNumber}>
                                <WhatsAppIcon
                                    className={classes.icon}
                                    style={{
                                        verticalAlign: "middle",
                                        color: "#890608",
                                    }}
                                />
                                <a
                                    href="whatsapp://send?phone=+237655959595"
                                    style={{ textDecoration: "none", color: "inherit" }}
                                >
                                    {t("detail-annonce.numéro1")}
                                </a>
                            </span>
                            <br />
                            <span className={classes.phoneNumber}>
                                <WhatsAppIcon
                                    className={classes.icon}
                                    style={{
                                        verticalAlign: "middle",
                                        color: "#890608",
                                    }}
                                />
                                <a
                                    href="whatsapp://send?phone=+237659797979"
                                    style={{ textDecoration: "none", color: "inherit" }}
                                >
                                    {t("detail-annonce.numéro2")}
                                </a>
                            </span>
                        </div>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        {t("label.fermer")}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export { ContactButton, StickyBarContactButton };
